import * as React from 'react'

import styled from '@theme/styled-components'

interface Props {
  business: AdminBusiness
  onClick: () => void
  height?: number
}

const AdminBusinesses = ({ business, onClick, height = 100 }: Props) => {
  return (
    <BusinessContainer key={business.id} onClick={onClick} height={height}>
      <LettersNameContainer>
        <LettersName>{business.title.slice(0, 1)}</LettersName>
      </LettersNameContainer>
      <BusinessInformation>
        <BusinessNames>{business.title}</BusinessNames>
        <BusinessRole>{business.subtitle}</BusinessRole>
      </BusinessInformation>
    </BusinessContainer>
  )
}

export default AdminBusinesses

const BusinessContainer = styled('div')<{ height: number }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px 25px 4px 25px;
  height: ${(props) => props.height - 10}px;
  border: 0px solid #f1f1f1;
  border-bottom-width: 1px;
  &: hover {
    background-color: ${(props) => props.theme.colors.filterBackgroundColor};
  }
`
const LettersNameContainer = styled('div')`
  background-color: ${(props) => props.theme.colors.primary_blue};
  height: 60px;
  width: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`
const LettersName = styled('div')`
  ${(props) => props.theme.fonts.calendarLibelle};
  color: ${(props) => props.theme.colors.secondary_text};
  text-align: center;
`
const BusinessInformation = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
`
const BusinessNames = styled('div')`
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 17px;
  line-height: 21px;
  color: #2d2a26;
`
const BusinessRole = styled('div')`
  font-family: Avenir;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 21px;
  color: #2d2a26;
`
